export const YANDEX_AUTH_CLIENT_ID = process.env.NEXT_PUBLIC_YANDEX_AUTH_CLIENT_ID;
export const YANDEX_AUTH_REDIRECT_URI = process.env.NEXT_PUBLIC_YANDEX_AUTH_REDIRECT_URI;
export const YANDEX_AUTH_RESPONSE_TYPE = "token";

export const VK_AUTH_CLIENT_ID = Number(process.env.NEXT_PUBLIC_VK_AUTH_CLIENT_ID);
export const VK_AUTH_REDIRECT_URI = String(process.env.NEXT_PUBLIC_VK_AUTH_REDIRECT_URI);

export const TG_AUTH_ID = Number(process.env.NEXT_PUBLIC_TG_ID);

export const TOKEN_KEY = "token";
export const REFRESH_TOKEN_KEY = "refreshToken";
export const UUID_TOKEN_KEY = "uuid";